import React from 'react';
import { createPortal } from 'react-dom';

const OrderDetailsToast = ({ toast, setToast }) => {
  if (!toast.show || typeof document === 'undefined') return null;

  return createPortal(
    <div className={`toast-notification ${toast.type}`}>
      <div className="toast-content">
        <div className="toast-icon">
          <i className={`fas ${toast.type === 'success' ? 'fa-check' : toast.type === 'error' ? 'fa-exclamation' : 'fa-info'}`}></i>
        </div>
        <div className="toast-message">{toast.message}</div>
        <button className="toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      <div className="toast-progress"></div>
    </div>,
    document.body
  );
};

export default OrderDetailsToast;
